export default "Récupération de chaleur fatale industrielle (fumées, condensats, air vicié, vapeur basse pression) via échangeur dimensionné : fiche CEE IND-UT-131. Pré-chauffage process, ECS, réseau de chaleur. Coup de pouce possible.";
